module.exports = __webpack_public_path__ + "media/components/breakheader/background/background--3-8ab47000230701183bb98dc330515a67.jpg";